<div class="sidebar-container">
  <ul>
    <li *ngFor="let period of datePeriods" class="radio-button-container global-transition" [ngClass]="{'active' : selectedPeriod === period}">
      <label class="container global-transition"
        >{{ 'view_translations.period_' + period | translate }}
        <input type="radio" id="{ period }" name="datePeriod" (change)="selectedValue(period)" [checked]="selectedPeriod === period" />
        <span class="checkmark"></span>
      </label>
    </li>
  </ul>
</div>
